import UserService from "../../Services/UserService";

export const FETCH_USERS_REQUEST = "FETCH_USERS_REQUEST";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE";

export const FETCH_USERS_COUNT_REQUEST = "FETCH_USERS_COUNT_REQUEST";
export const FETCH_USERS_COUNT_SUCCESS = "FETCH_USERS_COUNT_SUCCESS";
export const FETCH_USERS_COUNT_FAILURE = "FETCH_USERS_COUNT_FAILURE";

export const fetchUsers = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_USERS_REQUEST });
    try {
        const response = await UserService.getUser(payload);
        dispatch({ type: FETCH_USERS_SUCCESS, payload: response.data });
    }
    catch (error) {
        dispatch({ type: FETCH_USERS_FAILURE, payload: error.message });
    }
}

export const fetchUsersCount = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_USERS_COUNT_REQUEST });
    try {
        const response = await UserService.getUserCount(payload);
        dispatch({ type: FETCH_USERS_COUNT_SUCCESS, payload: response.data.TOTAL_COUNT_STATUS });
    }
    catch (error) {
        dispatch({ type: FETCH_USERS_COUNT_FAILURE, payload: error.message });
    }
}